import { motion } from 'framer-motion';

const ServicesHero = () => {
  return (
    <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/71a63bb27dce4a9d35042e76c21e90ff.jpg"
          alt="サービス"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            サービス内容
          </h1>
          <p className="text-xl text-white/90 mb-12 leading-relaxed">
            経営者の皆様の課題に寄り添い、
            <br />
            最適なソリューションを提供します
          </p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfcI_iqOXmdZhJO8vkCvjObLY5GxPIAQ8kXxWKDFswsKGrSRQ/viewform?usp=publish-editor"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-red text-white px-8 py-4 rounded-full font-medium hover:bg-red/90 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
          >
            <span>無料相談を予約する</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesHero;